<template>
  <div class="cancellationAgreement">
    <div class="content">
      <h1>账号注销协议</h1>
      <p class="paragraph">游客您好，在您正式进入账号注销流程前，我们先向您做出如下说明：</p>
      <p class="remind">账号注销后，您在该账号下的个人信息将彻底删除，无法恢复，请您谨慎操作。</p>
      <p class="paragraph">若您经过慎重考虑后仍决定注销本账号，请您务必仔细阅读以下协议，并同意本协议全部内容：</p>
      <p>一、账号一旦注销，立即生效。您将无法登录、使用该账号</p>
      <p>二、您曾通过该账号购买、使用的订单将全部删除。无法通过任何途径再继续使用和找回。</p>
      <p>三、申请账号注销表示您同意自动放弃历史订单可能产生的退票权益。</p>
      <p>四、申请账号注销表示您同意删除该账号在使用期间产生的所有购票记录及发票申请。</p>
      <p>五、其他因账号注销产生的结果。</p>
      <p>六、请确认账号无以下情况：</p>
      <p class="paragraph">（1）无可使用订单</p>
      <p class="paragraph">（2）无可退票订单</p>
      <p class="paragraph">（3）无待支付订单</p>
      <p>如在账号注销过程中有任何问题可联系客服协助处理。</p>
      <div class="confirm">
        <img v-if="ckeckConfirm" @click="changeCkeckConfirm" src="~@/assets/image/common/common_tick.png" alt="">
        <img @click="changeCkeckConfirm" v-else src="~@/assets/image/common/common_unchecked.png" alt="">
        <span @click="changeCkeckConfirm">我已阅读并同意以上协议内容</span>
      </div>
    </div>
    <div class="options">
      <button @click="goGuideList">取消</button>
      <button @click="confirmCancellation">确认注销</button>
    </div>
    <selectpopup
      v-if="popupstate"
      @onselectpopup="onselectpopup"
      title="注销申请"
      content="是否确定要注销？">
    </selectpopup>
  </div>
</template>

<script>
  import { getCancelApply } from '@/service/user/userguide.js'
  export default {
    name: "cancellationAgreement",
    data() {
      return {
        ckeckConfirm: false,
        popupstate: false
      }
    },
    methods: {
      changeCkeckConfirm(){
        this.ckeckConfirm = !this.ckeckConfirm;
      },
      goGuideList(){
        this.$router.push('/userguide');
      },
      async onselectpopup(state){
        this.popupstate = false;
        if(state === 'determine'){
          const { userId } = JSON.parse(window.localStorage.getItem('userInfo'));
          const { appCode } = await getCancelApply.call(this, {
            userId
          });
          if(appCode === "1"){
            window.localStorage.clear();
            window.sessionStorage.clear();
            return this.$router.push('/')
          }
        }
      },
      confirmCancellation(){
        if(!this.ckeckConfirm)return this.$toast('请仔细阅读并确认协议内容');
        this.popupstate = !this.popupstate;
      }
    }
  };
</script>

<style scoped lang='less'>
.cancellationAgreement{
  background: #FFFFFF;
  min-height: 100vh;
  color: #333333;
  .content{
    padding: 0 .4rem .48rem;
    font-size: .4rem;
    line-height: .56rem;
    border-bottom: 1px solid rgba(151, 151, 151, 0.16);
    h1{
      font-size: .48rem;
      font-weight: bold;
      line-height: .6667rem;
      text-align: center;
      padding: .4rem 0 .2rem;
    }
    p{
      margin-bottom: .1733rem;
      &:last-child{
        margin-bottom: 0;
      }
    }
    .paragraph{
      text-indent: 2em;
    }
    .remind{
      color: #FF372B;
    }
    .confirm{
      display: flex;
      align-items: center;
      img{
        width: .5067rem;
        height: .5067rem;
      }
      span{
        margin-left: .1733rem;
        font-weight: bold;
      }
    }
  };
  .options{
    padding: .2667rem .4rem;
    display: flex;
    justify-content: space-between;
    button{
      width: 4.4rem;
      height: 1.2rem;
      border-radius: .6rem;
      border: 1px solid #333333;
      font-size: .4rem;
      color: #333333;
      line-height: 1.2rem;
      text-align: center;
    }
  }
}
</style>
